import { render, staticRenderFns } from "./telegram.vue?vue&type=template&id=0a94b85c&scoped=true&"
var script = {}
import style0 from "./telegram.vue?vue&type=style&index=0&id=0a94b85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94b85c",
  null
  
)

export default component.exports